/**
 * Bug #452
 * @Author Santhosh Kumar
 * @Date 21 June 2021
 */
import axios from "axios";
import {
  API_PROVIDER_SEARCH, API_GET_PROVIDER_PROFILE, API_GET_PRACTICE_PROFILE, API_GET_ALL_PROVIDERS_BY_PRACTICE_ID, API_QR_CODE_GENERATE_PROVIDER, API_GET_LIST_FORM, API_UPDATE_LIST_FORM, API_GET_ALL_PATIENTS, API_LIST_MYPATIENTS, API_GET_PROVIDER_LISTAPPOINTMENTS, API_SCHEDULE_BROADCAST, API_GET_BROADCAST, API_DELETE_BROADCAST, API_EDIT_SCHEDULED_BROADCAST, API_RESCHEDULED_BROADCAST, API_GET_PROVIDER, API_GET_BROADCAST_TEMPLATE, API_GET_BROADCAST_TEMPLATE_DETAILS, API_GET_BROADCAST_PATIENT_GROUPS, API_GET_BROADCAST_PATIENTs, API_TEMPLATE_SAVE, API_LIST_TEMPLATE, API_DELETE_TEMPLATE, API_SAVE_PATIENT_GROUP, API_GET_PATIENT_GROUP_MEMBERS, API_GET_DEFAUTL_TEMPLATE, API_GET_TEMPLATE_BY_CATEGORY, API_PATIENT_GROUP_LIST, API_PATIENT_GROUP_DELETE, API_PATIENT_GROUP_MEMBERS, API_CREATE_PATIENT_GROUP, API_PAUSE_APPT_REMAINDER, API_PAUSE_APPT_EMAIL_CONFIRMATION, API_FORM_CONFIG_DETAILS, API_SELECT_APPTTYPES, API_SELECT_PROVIDERS, API_UPDATE_FORM, API_SAVE_CONFIG_DETAILS, API_GET_APPOINTMENTS_SEARCH, API_GET_PATIENT_SEARCH, API_GET_PS_PATIENT_GROUP_MEMBERS, API_GET_RECALL_TYPE, API_PAUSE_RECALL_REMAINDER, API_FIND_FORM_DATA
  , API_GET_PARENT_PROVIDER_LOCATIONS
} from 'api/endpoint';
import moment from "moment";


export const searchPracticeOrProvider = (filter, pageNo, pageSize) => {
  return axios.get(API_PROVIDER_SEARCH, {
    /** 
     * Bug#425
     * @Author: Linda Susan Raju 
     * @Date: 05 July 2021
     */
    params: {
      location: filter.location,
      name: filter.name,
      pageNo: pageNo,
      pageSize: pageSize
    }
    /**End Bug#425*/
  });
};

export const getProviderProfile = (slug) => {
  return axios.get(API_GET_PROVIDER_PROFILE, {
    params: {
      slug: slug,
    },
  });
};

export const getPracticeProfile = (slug) => {
  return axios.get(API_GET_PRACTICE_PROFILE, {
    params: {
      slug: slug,
    },
  });
};

export const searchFavoriteDoctor = (filter) => {
  return axios.get(`/api/find-favorite-doctor`, { params: {} });
};

export const addFavoriteDoctor = (data) => {
  return axios.get(`/api/add-favorite-doctor`, {
    params: {
      provId: data,
    },
  });
};
/*** End ***/

/**
 * To remove favourite doctor -bug #451
 * @Author Liya baby
 * @Date 29 June 2021
 * @param data 
 * @returns 
 */
export const removeFavoriteDoctor = (data) => {
  return axios.get(`api/deleteFavouriteDoctor`, {
    params: {
      provId: data,
    },
  });
};
/*** End ***/

/** 
 * Bug#425
 * @Author: Linda Susan Raju 
 * @Date: 05 July 2021
 */
export const getAllProvidersByPracticeId = (practiceId, pageNo, pageSize) => {

  return axios.get(API_GET_ALL_PROVIDERS_BY_PRACTICE_ID, {
    params: {
      practiceId: practiceId,
      pageNo: pageNo,
      pageSize: pageSize,
    },
  });
};
/**End Bug#425*/

/**
 * Bug #566
 * @Author Aby Joseph
 * @Date 25 August 2021
 */
export const generateProviderQrCode = (guid) => {
  return axios.get(API_QR_CODE_GENERATE_PROVIDER + guid)
};
/**End Bug#566*/

/**
 * Bug #655
 * @Author Midhila Velayudhan
 * @Date 03 November 2021
 */

export const getAllProviderFormsList = (practiceguid) => {
  return axios.get(API_GET_LIST_FORM, {
    params: {
      guid: practiceguid,
    }
  })
}

export const updateProviderFormsList = (params) => {
  return axios.post(API_UPDATE_LIST_FORM, params);
};
/** End Bug#655 */

/**Bug #744
 * Midhila Velayudhan
 * Date:15/02/2022
 */
export const getAllProviderAppointmentList = (portalAccountId, type, pageNo, pageSize) => {
  return axios.get(API_GET_PROVIDER_LISTAPPOINTMENTS, {
    params: {
      portalAccountId: portalAccountId,
      type: type,
      pageNo: pageNo,
      pageSize: pageSize,
      ...(type != '1' && { todayDate: moment(new Date()).format('YYYY-MM-DD') }), /**Bug#744 by Linda Susan Raju on 04Mar2022 */
    }
  })
}

/**Bug #878
 * Liya Baby
 * Date:30/05/2022
 */
export const getPsAppointment = (data) => {
  return axios.post(API_GET_APPOINTMENTS_SEARCH, data);

}
/**End Bug #744 */
export const getAllPatients = () => {
  return axios.get(API_GET_ALL_PATIENTS)
};

export const sendMessageToPatient = async (fcmTockens, message) => {
  const response = await fetch("https://fcm.googleapis.com/fcm/send", {
    cache: 'no-store',
    method: 'post',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'key=AAAAWNhmS7I:APA91bFDHsstlAIDByuYcun-dqVTuOT3TJ-cWoLc_IObyG9P1Fo5zoTRNoCPwMcYn-3V-moYxYwmzRXdP6dSDEka8KcTAARREJl2fOY3jSYtHUYuHbzpVdmRn6WtU5NG8RXBr7PacymO' },
    body: JSON.stringify({ 'registration_ids': fcmTockens, 'data': message }),
  });
  return response.json();
}
/** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Jithin Kuriakose @Date 03Mar2022 */
export const scheduleBroadcastJob = (data) => {
  //console.log(data);
  return axios.post(API_SCHEDULE_BROADCAST, data);
};
export const editScheduledBroadcastJob = (data) => {
  //console.log(data);
  return axios.post(API_EDIT_SCHEDULED_BROADCAST, data);
};
export const rescheduledBroadcastJob = (data) => {
  //console.log(data);
  return axios.post(API_RESCHEDULED_BROADCAST, data);
};
//End Bug #758
/**Bug #745 */
export const getProviderListPatients = (portalAccountId, pageNo, pageSize) => {
  return axios.get(API_LIST_MYPATIENTS, {
    params: {
      portalAccountId: portalAccountId,
      pageNo: pageNo,
      pageSize: pageSize,
    }
  })
}
/**End Bug# 745 */

export const getBroadcastMessages = (data) => {
  //console.log(data);
  return axios.get(API_GET_BROADCAST, { params: data });
};
export const deleteBroadcastMessages = (data) => {
  //console.log(data);
  return axios.delete(API_DELETE_BROADCAST, { params: data });
};
//End Bug #758

/*Bug #819-Appointment reschedule implementation  @Author: Aby Joseph  @Date: 07 Apr 2022*/
export const getProvider = (data) => {
  return axios.get(API_GET_PROVIDER, { params: data })
};
/*Bug #819-End*/

/** Bug #841 Date 26 april 2022 */
export const getPatientGroupList = (data) => {
  return axios.get(API_PATIENT_GROUP_LIST, { params: data })
};
/** End Bug */

export const createPatientGroup = (data) => {
  //console.log(data);
  return axios.post(API_CREATE_PATIENT_GROUP, data);
};
/** Bug#841 @Author: Midhila Velayudhan @Date: 29 april 2022*/
export const deletePatientGroup = (id) => {
  return axios.delete(API_PATIENT_GROUP_DELETE, {
    params: {
      id: id,

    }
  });
}

export const getAllpatientgroupMembers = (portalAccountId, pageNo, pageSize, patientGroupMasterId) => {
  return axios.get(API_PATIENT_GROUP_MEMBERS, {
    params: {
      portalAccountId: portalAccountId,
      pageNo: pageNo,
      pageSize: pageSize,
      patientGroupMasterId: patientGroupMasterId
    }
  })
}
export const getBroadcastMessagesTemplates = (data) => {
  //console.log("getBroadcastMessagesTemplates:",data);
  return axios.get(API_GET_BROADCAST_TEMPLATE, { params: data });
};
export const getBroadcastMessagesTemplateDetails = (data) => {
  //console.log(data);
  return axios.get(API_GET_BROADCAST_TEMPLATE_DETAILS, { params: data });
};
export const getBroadcastPatientGroup = (data) => {
  //console.log(data);
  return axios.get(API_GET_BROADCAST_PATIENT_GROUPS, { params: data });
};
export const getBroadcastPatientGroupList = (data) => {
  //console.log(data);
  return axios.get(API_GET_BROADCAST_PATIENTs, { params: data });
};
export const savePatientGroup = (data) => {
  //console.log(data);
  return axios.post(API_SAVE_PATIENT_GROUP, data);
};
/** Bug #838 Midhla Velayudhan Date :19 april 2022 */
export const saveMessageTemplate = (data) => {
  return axios.post(API_TEMPLATE_SAVE, data);
};

export const getTemplateMessages = (portalAccountId, pageNo, pageSize) => {
  return axios.get(API_LIST_TEMPLATE, {
    params: {
      portalAccountId: portalAccountId,
      pageNo: pageNo,
      pageSize: pageSize,
    }
  })
}

export const deleteTemplateMessage = (data) => {
  return axios.delete(API_DELETE_TEMPLATE, { params: data });
};

/**Bug #859
  * Liya Baby
  * Date:05/05/2022
  */
export const updateProviderForm = (params) => {
  return axios.post(API_UPDATE_FORM, params);
};

export const setSelectProviders = (portalAccountId, searchParam) => {
  return axios.get(API_SELECT_PROVIDERS, {
    params: {
      portalAccountId: portalAccountId,
      searchParam: searchParam,
    }
  })
};

export const setSelectApptTypes = (portalAccountId, searchParam) => {
  return axios.get(API_SELECT_APPTTYPES, {
    params: {
      portalAccountId: portalAccountId,
      searchParam: searchParam,
    }
  })
};
export const getFormConfigDetail = (portalAccountId, portalAccountFormsId) => {
  return axios.get(API_FORM_CONFIG_DETAILS, {
    params: {
      portalAccountId: portalAccountId,
      portalAccountFormsId: portalAccountFormsId,
    }
  })
};

export const saveFormConfigDetails = (data) => {
  return axios.post(API_SAVE_CONFIG_DETAILS, data);
};


/** End Bug#859 */
/**End */
/**End */

export const getPatientGroupMembers = (data) => {
  //console.log(data);
  return axios.get(API_GET_PATIENT_GROUP_MEMBERS, { params: data });
}
/** Date 21 apil 2022 */
export const getDefaulTemplate = (data) => {
  return axios.get(API_GET_DEFAUTL_TEMPLATE, { params: data })
};
export const getRecallType = (data) => {
  return axios.get(API_GET_RECALL_TYPE, { params: data })
};
/**End */
/** Date 26 april 2022 */
export const getDefaulTemplateByCategory = (data) => {
  return axios.get(API_GET_TEMPLATE_BY_CATEGORY, { params: data })
};
/*Bug #879 - Facility - Implement an option to turned off/on appointment recall, reminder, email confirmation @Author Jithin Kuriakose @Date 11 May 2022*/
export const pauseApptReminderJob = (jobName, jobGroupName, portalApptReminderOptionsId, isPaused) => {
  return axios.get(API_PAUSE_APPT_REMAINDER, {
    params: {
      jobName: jobName,
      jobGroupName: jobGroupName,
      portalApptReminderOptionsId: portalApptReminderOptionsId,
      isPaused: isPaused,
    }
  })
}
export const pauseRecallReminderJob = (jobName, jobGroupName, portalRecallJobId, isPaused) => {
  return axios.get(API_PAUSE_RECALL_REMAINDER, {
    params: {
      jobName: jobName,
      jobGroupName: jobGroupName,
      portalRecallJobId: portalRecallJobId,
      isPaused: isPaused,
    }
  })
}
//End Bug #879
export const pauseTemplate = (params) => {
  return axios.get(API_PAUSE_APPT_EMAIL_CONFIRMATION, {
    params: params
  })
}
/** Bug #939  */
export const getPsPatient = (data) => {
  return axios.post(API_GET_PATIENT_SEARCH, data);

}
/** End */

/** Bug #841 - Implement Patient Groups in facility @Author: Jithin Kuriakose @Date 17Jun2022 */
export const getPSPatientGroupMembers = (data) => {
  //console.log(data);
  return axios.get(API_GET_PS_PATIENT_GROUP_MEMBERS, { params: data });
}

export const getAllPSPatientgroupMembers = (portalAccountId, pageNo, pageSize, patientGroupMasterId) => {
  return axios.get(API_GET_PS_PATIENT_GROUP_MEMBERS, {
    params: {
      portalAccountId: portalAccountId,
      pageNo: pageNo,
      pageSize: pageSize,
      patientGroupMasterId: patientGroupMasterId,
      type: "SEARCH"
    }
  })
}
/**End Bug #841 */

/*Bug #1004 - @Author: Aby Joseph @Date 05Aug2022 */
export const getFormData = (params) => {
  return axios.get(API_FIND_FORM_DATA, {
    params: { portalAccountFormsId: params }
  })
}
/**End Bug #1004 */

/**End Bug #841 */
/**
 * Get Provider Locations
 * @param portalProviderId 
 * @author Omar Fayadh
 * @bug
 * @returns 
 */
export const getProviderLocation = (params) => {

  return axios.get(API_GET_PARENT_PROVIDER_LOCATIONS, {
    params: params

  })

}